// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --field-background-color: var(--base-20);
}

.TimeField__content-d67061 {
  display: block;
  padding: 14px 12px;
  position: relative;
  height: 52px;
  background-color: var(--field-background-color);
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
  border-color: transparent;
}

.TimeField__content-d67061:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-bottom: 2px solid transparent;
  border-bottom-color: inherit;
}

.TimeField__hour-24-f207e5 {
  min-width: 105px;
}

.TimeField__hour-12-c79fee {
  min-width: 140px;
}

.TimeField__focused-bce5dc {
  border-color: var(--brand-secondary-40);
}

.TimeField__success-b0181f .TimeField__label-e316a3,
.TimeField__success-b0181f + .TimeField__helper-text-af7527 {
  color: var(--success-30);
}

.TimeField__success-b0181f {
  border-color: var(--success-30);
}

.TimeField__error-a6b2f8 .TimeField__label-e316a3,
.TimeField__error-a6b2f8 + .TimeField__helper-text-af7527 {
  color: var(--danger-40);
}

.TimeField__error-a6b2f8 {
  border-color: var(--danger-40);
}

.TimeField__disabled-bd69a2 .TimeField__label-e316a3 {
  color: var(--base-50);
}

.TimeField__disabled-bd69a2,
.TimeField__disabled-bd69a2 .TimeField__input-bc367c::placeholder {
  color: var(--base-50);
}

.TimeField__label-e316a3 {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  z-index: 1;
  transform: translate(12px, 14px) scale(1);
  transform-origin: top left;
  pointer-events: none;
  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.TimeField__small-label-c1892e {
  transform: translate(12px, 6px) scale(0.75);
}

.TimeField__input-bc367c {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  background-color: transparent;
  z-index: 2;
  box-sizing: border-box;
}

.TimeField__input-bc367c::-webkit-datetime-edit-text {
  display: inline-block;
  padding: 0 2px;
}

.TimeField__input-bc367c::-webkit-datetime-edit-hour-field,
.TimeField__input-bc367c::-webkit-datetime-edit-minute-field,
.TimeField__input-bc367c::-webkit-datetime-edit-second-field,
.TimeField__input-bc367c::-webkit-datetime-edit-ampm-field {
  display: inline-block;
  height: 24px;
  padding: 0 2px;
  background-color: transparent;
  border-radius: 4px;
}

.TimeField__input-bc367c::-webkit-datetime-edit-hour-field:focus,
.TimeField__input-bc367c::-webkit-datetime-edit-minute-field:focus,
.TimeField__input-bc367c::-webkit-datetime-edit-second-field:focus,
.TimeField__input-bc367c::-webkit-datetime-edit-ampm-field:focus {
  background-color: var(--brand-secondary-40_30);
}

.TimeField__input-bc367c::-webkit-calendar-picker-indicator {
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
}

.TimeField__input-icon-f2956e {
  position: absolute;
  display: flex;
  align-items: center;
  width: 24px;
  height: 100%;
  top: 0;
  right: 0;
  background-color: var(--field-background-color);
  z-index: 1;
}

@supports (-moz-appearance: none) {
  .TimeField__input-icon-f2956e {
    z-index: 3;
  }
}
.TimeField__input-icon-f2956e svg * {
  fill: var(--base-80);
}

.TimeField__resizer-a193cc {
  display: flex;
  position: relative;
  height: 100%;
  min-width: 100%;
}

.TimeField__placeholder-e992f1 + .TimeField__resizer-a193cc {
  display: inline-flex;
}

.TimeField__hidden_placeholder-e92c2d {
  white-space: pre;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  background-color: var(--field-background-color);
  opacity: 0;
}

.TimeField__placeholder-e992f1 {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  padding: 14px 12px 12px;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  pointer-events: none;
}

.TimeField__with-label-f297ba {
  padding-bottom: 4px;
}

.TimeField__with-label-f297ba .TimeField__input-bc367c {
  padding: 8px 0 0;
  background-color: transparent;
}

.TimeField__helper-text-af7527 {
  height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--base-80);
  margin-top: 4px;
  padding: 0 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/TimeField/TimeField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,+CAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,oCAAA;EACA,4BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;;EAEE,wBAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;;EAEE,uBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;;EAEE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EAEA,wBAAA;EACA,0CAAA;EACA,qBAAA;EAEA,UAAA;EACA,yCAAA;EACA,0BAAA;EACA,oBAAA;EACA,sGAAA;AADF;;AAKA;EACE,2CAAA;AAFF;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,sBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,cAAA;AAFF;;AAKA;;;;EAIE,qBAAA;EACA,YAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;AAFF;;AAKA;;;;EAIE,8CAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,+CAAA;EACA,UAAA;AAFF;;AAKA;EACE;IACE,UAAA;EAFF;AACF;AAKA;EACE,oBAAA;AAHF;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAHF;;AAMA;EACE,oBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,+CAAA;EACA,UAAA;AAHF;;AAMA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,6BAAA;AAHF;;AAMA;EACE,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAHF","sourcesContent":[":root {\n  --field-background-color: var(--base-20);\n}\n\n.content {\n  display: block;\n  padding: 14px 12px;\n  position: relative;\n  height: 52px;\n  background-color: var(--field-background-color);\n  border-radius: 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n  border-color: transparent;\n}\n\n.content:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  border-bottom: 2px solid transparent;\n  border-bottom-color: inherit;\n}\n\n.hour-24 {\n  min-width: 105px;\n}\n\n.hour-12 {\n  min-width: 140px;\n}\n\n.focused {\n  border-color: var(--brand-secondary-40);\n}\n\n.success .label,\n.success + .helper-text {\n  color: var(--success-30);\n}\n\n.success {\n  border-color: var(--success-30);\n}\n\n.error .label,\n.error + .helper-text {\n  color: var(--danger-40);\n}\n\n.error {\n  border-color: var(--danger-40);\n}\n\n.disabled .label {\n  color: var(--base-50);\n}\n\n.disabled,\n.disabled .input::placeholder {\n  color: var(--base-50);\n}\n\n.label {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n\n  z-index: 1;\n  transform: translate(12px, 14px) scale(1);\n  transform-origin: top left;\n  pointer-events: none;\n  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,\n    transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n}\n\n.small-label {\n  transform: translate(12px, 6px) scale(0.75);\n}\n\n.input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  background-color: transparent;\n  z-index: 2;\n  box-sizing: border-box;\n}\n\n.input::-webkit-datetime-edit-text {\n  display: inline-block;\n  padding: 0 2px;\n}\n\n.input::-webkit-datetime-edit-hour-field,\n.input::-webkit-datetime-edit-minute-field,\n.input::-webkit-datetime-edit-second-field,\n.input::-webkit-datetime-edit-ampm-field {\n  display: inline-block;\n  height: 24px;\n  padding: 0 2px;\n  background-color: transparent;\n  border-radius: 4px;\n}\n\n.input::-webkit-datetime-edit-hour-field:focus,\n.input::-webkit-datetime-edit-minute-field:focus,\n.input::-webkit-datetime-edit-second-field:focus,\n.input::-webkit-datetime-edit-ampm-field:focus {\n  background-color: var(--brand-secondary-40_30);\n}\n\n.input::-webkit-calendar-picker-indicator {\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.input-icon {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  width: 24px;\n  height: 100%;\n  top: 0;\n  right: 0;\n  background-color: var(--field-background-color);\n  z-index: 1;\n}\n\n@supports (-moz-appearance: none) {\n  .input-icon {\n    z-index: 3;\n  }\n}\n\n.input-icon svg * {\n  fill: var(--base-80);\n}\n\n.resizer {\n  display: flex;\n  position: relative;\n  height: 100%;\n  min-width: 100%;\n}\n\n.placeholder + .resizer {\n  display: inline-flex;\n}\n\n.hidden_placeholder {\n  white-space: pre;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  background-color: var(--field-background-color);\n  opacity: 0;\n}\n\n.placeholder {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: block;\n  padding: 14px 12px 12px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  pointer-events: none;\n}\n\n.with-label {\n  padding-bottom: 4px;\n}\n\n.with-label .input {\n  padding: 8px 0 0;\n  background-color: transparent;\n}\n\n.helper-text {\n  height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--base-80);\n  margin-top: 4px;\n  padding: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TimeField__content-d67061`,
	"hour-24": `TimeField__hour-24-f207e5`,
	"hour24": `TimeField__hour-24-f207e5`,
	"hour-12": `TimeField__hour-12-c79fee`,
	"hour12": `TimeField__hour-12-c79fee`,
	"focused": `TimeField__focused-bce5dc`,
	"success": `TimeField__success-b0181f`,
	"label": `TimeField__label-e316a3`,
	"helper-text": `TimeField__helper-text-af7527`,
	"helperText": `TimeField__helper-text-af7527`,
	"error": `TimeField__error-a6b2f8`,
	"disabled": `TimeField__disabled-bd69a2`,
	"input": `TimeField__input-bc367c`,
	"small-label": `TimeField__small-label-c1892e`,
	"smallLabel": `TimeField__small-label-c1892e`,
	"input-icon": `TimeField__input-icon-f2956e`,
	"inputIcon": `TimeField__input-icon-f2956e`,
	"resizer": `TimeField__resizer-a193cc`,
	"placeholder": `TimeField__placeholder-e992f1`,
	"hidden_placeholder": `TimeField__hidden_placeholder-e92c2d`,
	"hiddenPlaceholder": `TimeField__hidden_placeholder-e92c2d`,
	"with-label": `TimeField__with-label-f297ba`,
	"withLabel": `TimeField__with-label-f297ba`
};
module.exports = ___CSS_LOADER_EXPORT___;
